import { Link } from "react-router-dom";
import { categories, mainSiteUrl } from "@/mocks/categories";

export default function Footer() {
  const footerCategories = [
    { label: "Shoes", url: categories[0].url },
    { label: "Hoodies / Sweaters", url: categories[1].url },
    { label: "T-Shirts", url: categories[2].url },
    { label: "Jackets", url: categories[3].url },
    { label: "Pants / Shorts", url: categories[4].url },
    { label: "Headwear", url: categories[5].url },
    { label: "Sets", url: categories[6].url },
  ];

  const footerLinks = [
    { label: "Bags", url: categories[10].url },
    { label: "Belts", url: categories[11].url },
    { label: "Perfumes", url: categories[12].url },
    { label: "Accessories", url: categories[9].url },
    { label: "Jersey", url: categories[8].url },
    { label: "Underwear", url: categories[7].url },
    { label: "Other Stuff", url: categories[13].url },
  ];

  const quickLinks = [
    { label: "ACBuy Spreadsheet Guide", url: "/acbuy-spreadsheet-guide" },
    { label: "Full Review", url: "/acbuy-spreadsheet-review" },
    { label: "Safety Guide", url: "/acbuy-spreadsheet-safety" },
    { label: "Pricing Explained", url: "/acbuy-spreadsheet-pricing" },
    { label: "Category Breakdown", url: "/acbuy-spreadsheet-categories" },
    { label: "ACBuy Spreadsheet", url: mainSiteUrl, external: true },
    { label: "Buy It Now", url: mainSiteUrl, external: true },
  ];

  return (
    <footer className="bg-background-50 border-t border-background-200">
      <div className="w-full px-4 md:px-8 py-14 md:py-20">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-0">
          {/* Left Section */}
          <div className="lg:w-[40%]">
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 leading-tight">
              Ready to Start<br />Sourcing Smarter?
            </h2>
            <p className="mt-4 text-sm text-foreground-600 max-w-sm leading-relaxed">
              Access the latest acbuy spreadsheet and discover verified product listings updated regularly for global buyers sourcing from China.
            </p>
            <div className="mt-10">
              <a
                href={mainSiteUrl}
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full border-2 border-foreground-800 text-foreground-800 text-sm font-semibold hover:bg-foreground-800 hover:text-background-50 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                Go to Main Platform
                <i className="ri-arrow-right-up-line"></i>
              </a>
            </div>
          </div>

          {/* Right Section */}
          <div className="lg:w-[60%] grid grid-cols-2 md:grid-cols-3 gap-8 md:gap-12">
            {/* Column 1 */}
            <div>
              <h4 className="text-xs font-semibold text-foreground-400 uppercase tracking-wider mb-5">Categories</h4>
              <ul className="space-y-3">
                {footerCategories.map((item) => (
                  <li key={item.label}>
                    <a
                      href={item.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors cursor-pointer"
                    >
                      {item.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Column 2 */}
            <div>
              <h4 className="text-xs font-semibold text-foreground-400 uppercase tracking-wider mb-5">More Categories</h4>
              <ul className="space-y-3">
                {footerLinks.map((item) => (
                  <li key={item.label}>
                    <a
                      href={item.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors cursor-pointer"
                    >
                      {item.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Column 3 */}
            <div>
              <h4 className="text-xs font-semibold text-foreground-400 uppercase tracking-wider mb-5">Quick Links</h4>
              <ul className="space-y-3">
                {quickLinks.map((item) => (
                  <li key={item.label}>
                    {item.external ? (
                      <a
                        href={item.url}
                        target="_blank"
                        rel="noopener nofollow"
                        className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors cursor-pointer"
                      >
                        {item.label}
                      </a>
                    ) : (
                      <Link
                        to={item.url}
                        className="text-sm text-foreground-600 hover:text-foreground-900 transition-colors cursor-pointer"
                      >
                        {item.label}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-background-200">
        <div className="w-full px-4 md:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} ACBuy Team. All rights reserved. This is an informational SEO hub.
          </p>
          <div className="flex items-center gap-6">
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors cursor-pointer"
            >
              Main Site
            </a>
            <a
              href="#"
              className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors cursor-pointer"
            >
              Privacy
            </a>
            <a
              href="#"
              className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors cursor-pointer"
            >
              Terms
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}